import http from './http';

// Локальный кэш accountId → equipment[], НЕ Vuex — поповер дёргается очень часто (hover),
// а список оборудования сотрудника почти не меняется в рамках одной сессии.
const cache = new Map();

export function getAccountEquipment(accountId) {
    if (!cache.has(accountId)) {
        // Кэшируется сам промис, поэтому упавший запрос обязательно выкидываем из кэша: иначе
        // один 500/таймаут залипал бы навсегда и все последующие наведения на этого сотрудника
        // мгновенно реджектились бы тем же результатом, без единой повторной попытки.
        cache.set(
            accountId,
            http
                .get(`/accounts/${accountId}/equipment`)
                .then(({ data }) => data)
                .catch((error) => {
                    cache.delete(accountId);

                    throw error;
                }),
        );
    }

    return cache.get(accountId);
}
